import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'client';

const ClientService = {
  getPagedResult({
    page,
    limit,
    searchText,
    searchBy
  }) {
    return Http.get(`/${RESOURCE_NAME}?page=${page}&limit=${limit}&searchText=${searchText}&searchBy=${searchBy}&orders[id]=DESC`);
  },
  getInitFormData() {
    return {
      name: '',
      clientLocations: [
        this.getInitLocation()
      ],
      logoFile: null,
      createdAt: new Date(),
      clientContacts: [
        this.getInitContact()
      ]
    };
  },
  getInitContact() {
    return {
      id: null,
      gender: null,
      name: '',
      email: '',
      telephone: '',
      mobile: ''
    };
  },
  getInitLocation() {
    return {
      identity: '',
      address: '',
      codePostal: '',
      city: '',
      countryId: null
    };
  },
  getList() {
    return Http.get(`/${RESOURCE_NAME}/list`);
  },
  getById(id) {
    return Http.get(`/${RESOURCE_NAME}/${id}`);
  },
  delete(id) {
    return Http.delete(`/${RESOURCE_NAME}/${id}`);
  },
  create(object) {
    // Cast data to form data
    const formData = new FormData();
    Object.keys(object)
      .forEach((fieldName) => {
        if (Array.isArray(object[fieldName])) {
          object[fieldName].forEach((item, key) => {
            Object.keys(item).forEach(subKey => {
              const newFieldName = `${fieldName}[${key}][${subKey}]`;
              formData.append(newFieldName, item[subKey]);
            });
          });
        } else {
          formData.append(fieldName, object[fieldName] ? object[fieldName] : '');
        }
      });

    return Http.post(`/${RESOURCE_NAME}`, formData);
  },
  update(id, object) {
    // Cast data to form data
    const formData = new FormData();
    Object.keys(object)
      .forEach((fieldName) => {
        if (Array.isArray(object[fieldName])) {
          object[fieldName].forEach((item, key) => {
            Object.keys(item).forEach(subKey => {
              const newFieldName = `${fieldName}[${key}][${subKey}]`;
              formData.append(newFieldName, item[subKey]);
            });
          });
        } else {
          formData.append(fieldName, object[fieldName] ? object[fieldName] : '');
        }
      });

    return Http.post(`/${RESOURCE_NAME}/${id}`, formData);
  }
};

export default ClientService;
